import { mapGetters, mapActions } from 'vuex'
import {
  messageServiceInstance,
  emojiDictionary,
} from '@/services/MessageService'

const MessageService = messageServiceInstance()

export default {
  data() {
    return {
      emoji: emojiDictionary,
      quickMessages: [],
    }
  },
  computed: {
    ...mapGetters('userStates', ['getProfileId']),
  },
  methods: {
    ...mapActions('resourcesStates', ['downloadResourceByUrl']),
    ...mapActions('userStates', ['getProfileQuickMessages']),
    ...mapActions('chatStates', [
      'getMessageByTimetoken',
      'addChatMessage',
      'addMessageAction',
      'removeMessageAction',
      'markMessagesAsRead',
      'ackMessage',
      'removeMessage',
      'sendChatSignal',
      'toggleChannelIsPinned',
      'getFileUrl',
      'downloadFile',
      'setContactSelectionOptionIsSingle',
      'setCurrentChannel',
      'copyMessage',
      'setChatArchive',
    ]),
    getMessageByTimetokenHandler({ channelId, timetoken }) {
      return this.getMessageByTimetoken({ channelId, timetoken })
    },
    copyMessageHandler(messageText = '') {
      this.copyMessage({ messageText })
    },
    addMessage({
      messageText,
      messageLanguage,
      needAck,
      file,
      mediaLibraryFiles = null,
      giphyFile = null,
      replyMessageTimetoken = null,
    }) {
      this.addChatMessage({
        messageText,
        messageLanguage,
        needAck,
        file,
        mediaLibraryFiles,
        giphyFile,
        replyMessageTimetoken,
      })
    },
    ackMessageHandler(message) {
      this.ackMessage(message)
    },
    removeMessageHandler(message) {
      this.removeMessage(message)
    },
    channelSelected(channel) {
      this.setCurrentChannel(channel)
    },
    markMessagesAsReadHandler() {
      this.markMessagesAsRead()
    },
    addMessageActionHandler({ message, type, value }) {
      this.addMessageAction({ message, type, value })
    },
    removeMessageActionHandler(action) {
      this.removeMessageAction(action)
    },
    sendWritingSignal({ channel, type }) {
      this.sendChatSignal({ channel, type })
    },
    parseInputMessageText(text) {
      return MessageService.parseInputText(text)
    },
    parseOutputMessageText(text) {
      return MessageService.parseOutputText(text)
    },
    getQuickMessages() {
      this.getProfileQuickMessages({ profileId: this.getProfileId }).then(
        response => {
          this.quickMessages = [...response.subobjects] || []
        },
      )
    },
    toggleChannelIsPinnedHandler(chat) {
      this.toggleChannelIsPinned(chat)
    },
    setCurrentChatArchive(chat) {
      this.setChatArchive(chat)
    },
    getFileUrlHandler(file) {
      return this.getFileUrl(file)
    },
    downloadResourceByUrlHandler(resourceUrl) {
      this.downloadResourceByUrl({ resourceUrl })
    },
    downloadFileHandler(file) {
      this.downloadFile({ file })
    },
    setContactSelectionOptionIsSingleHandler(value) {
      this.setContactSelectionOptionIsSingle(value)
    },
  },
}
